import React from 'react';
import { CreateMerchantProfileForm } from '../components/CreateMerchantProfileForm';

export const CreateMerchantProfilePage: React.FC = () => {
  return (
    <div className="container mx-auto py-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight">Create Merchant Profile</h1>
          <p className="text-muted-foreground mt-2">
            Create a new merchant profile by selecting a merchant and providing the necessary configuration.
          </p>
        </div>

        <CreateMerchantProfileForm />
      </div>
    </div>
  );
};
